import Cookies from 'js-cookie';

const LANDING_UTM_COOKIE = 'landingPageUTMParams';

interface UTMParams {
  [key: string]: string | undefined;
}

export const readLandingPageCookie = (): UTMParams | undefined => {
  return Cookies.getJSON(LANDING_UTM_COOKIE);
};

export const writeToLandingPageCookie = (newData: UTMParams): void => {
  const cookieValue = readLandingPageCookie();
  const newValue: UTMParams = {
    ...cookieValue,
    ...newData,
  };
  Cookies.set(LANDING_UTM_COOKIE, newValue);
};
